import { ColDef, GridOptions } from 'ag-grid-community';
import { withDefaultHeaderToolTip } from 'src/utils/ag-grid/withDefaultHeaderToolTip';
import { numberWithSpaces } from 'src/utils/numberWithSpaces';
import { SummaryData } from '../calculateSummary';

export interface StoreSalesSummarySummaryRow extends SummaryData {
    id: number;
    storeName: string;
}

export interface CategorySalesSummaryRow extends SummaryData {
    id: number;
    categoryName: string;
}

const createNameColumn = (field: 'storeName' | 'categoryName', headerName: string): ColDef => ({
    field,
    headerName,
    pinned: 'left',
    lockPinned: true,
    valueFormatter: (params) => {
        return params.value ?? 'Unknown';
    },
});

export const createTotalBoldRowStyle = (field: 'storeName' | 'categoryName'): GridOptions => ({
    getRowStyle: (params) => {
        if (params.data?.[field] === 'Total') {
            return { fontWeight: 'bold' };
        }
    },
});

export const defaultColDef: ColDef<SummaryData> = {
    editable: false,
    sortable: true,
    valueFormatter: (params) => {
        return numberWithSpaces(params.value);
    },
};

export const sharedColumns: ColDef[] = withDefaultHeaderToolTip([
    {
        field: 'totalStockValue',
        headerName: 'Total stock value',
    },
    {
        field: 'totalStockValueOnSale',
        headerName: 'Stock value on sale',
    },
    {
        field: 'totalStockValueNotOnSale',
        headerName: 'Stock value not on sale',
    },
    {
        field: 'percentageStockValueOnSale',
        headerName: '% stock value on sale',
        valueFormatter: (params) => {
            return numberWithSpaces(params.value, { postfix: '%' });
        },
    },
    {
        field: 'avgMarkDown',
        headerName: 'Avg. markdown %',
        valueFormatter: (params) => {
            return numberWithSpaces(params.value, { postfix: '%', default: 'N/A' });
        },
    },
    {
        field: 'stylesOnSale',
        headerName: 'No. of styles on sale',
    },
    {
        field: 'styleOptionsOnSale',
        headerName: 'No. of style options on sale',
    },
    {
        field: 'totalStockQuantity',
        headerName: 'Total stock quantity',
    },
    {
        field: 'totalStockQuantityOnSale',
        headerName: 'Stock quantity on sale',
    },
    {
        field: 'totalStockQuantityNotOnSale',
        headerName: 'Stock quantity not on sale',
    },
    {
        field: 'percentageStockQuantityOnSale',
        headerName: '% stock quantity on sale',
        valueFormatter: (params) => {
            return numberWithSpaces(params.value, { postfix: '%' });
        },
    },
    {
        field: 'grossMarginPercent',
        headerName: 'GM%',
        valueFormatter: (params) => {
            return numberWithSpaces(params.value, { postfix: '%' });
        },
    },
]);

export const storeSalesSummaryColumns: ColDef<StoreSalesSummarySummaryRow>[] = withDefaultHeaderToolTip([
    createNameColumn('storeName', 'Store'),
    ...sharedColumns,
]);

export const categorySalesSummaryColumns: ColDef<CategorySalesSummaryRow>[] = withDefaultHeaderToolTip([
    createNameColumn('categoryName', 'Style category'),
    ...sharedColumns,
]);
